import { Controller } from "@hotwired/stimulus";

// Names the fee in the confirmation, so the last step before an irreversible
// waiver states which one is actually selected rather than "this fee".
// turbo_confirm can't do this — it's a static attribute and the choice is a
// radio.
export default class extends Controller {
  static targets = ["sku"];

  confirm(event) {
    const selected = this.selectedSku();
    if (!selected) return;

    const label = selected.dataset.waiveLabel;
    const amount = selected.dataset.waiveAmount;
    const message = [
      `This will waive the ${amount} ${label} for this order.`,
      "",
      "This action cannot be undone.",
      "",
      "Continue?"
    ].join("\n");

    if (!window.confirm(message)) {
      event.preventDefault();
    }
  }

  // Radios when several fees are waivable; a hidden field when only one is.
  selectedSku() {
    return this.skuTargets.find((input) => input.type === "hidden" || input.checked);
  }
}
